/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="aefaf6ac-b566-4ef3-a47f-d240b5ca972b" width="24.84" height="25.2" viewBox="0 0 24.84 25.2" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M6.66,1.19H18.31a1.49,1.49,0,0,1,1,.42l5.32,5.13a1.47,1.47,0,0,1,.46,1.08V23.89a1.5,1.5,0,0,1-1.5,1.5h-17a1.5,1.5,0,0,1-1.5-1.5V2.69A1.5,1.5,0,0,1,6.66,1.19Z" transform="translate(-0.79 -0.69)" style={{fill: "none",stroke: "#1570bc"}} className="icon-fill"/><path d="M19.19,1.65V6a1,1,0,0,0,1,1h4.49" transform="translate(-0.79 -0.69)" style={{fill: "none",stroke: "#1570bc",strokeLinecap: "round",strokeLinejoin: "round"}}/><rect y="9.48" width="19.98" height="9.24" rx="1" style={{fill: "#1570bc"}} className="icon-fill"/><path d="M4.39,18V15.69H5.53a1.89,1.89,0,0,0,2.13-2c0-1.23-.73-1.91-2.2-1.91H3.29V18Zm.94-3.16H4.39V12.63h1c.83,0,1.15.32,1.15,1.14S6.18,14.87,5.33,14.87ZM10.74,18c2,0,3-1.1,3-3.1v-.19c0-2-1.08-3-3-3H8.68V18Zm0-.87h-1V12.65h.88c1.19,0,1.89.5,1.89,2.08V15C12.55,16.56,12,17.16,10.75,17.16Zm5.19.87V15.4h2.12v-.86H15.94V12.65h2.73v-.86H14.84V18Z" transform="translate(-0.79 -0.69)" style={{fill: "#fff"}}/>
</svg>

    );
  }
}

Icon.displayName = 'PdfIcon';

export default Icon;
